import Select from "react-select";
import { IoMdArrowDropdown, IoMdClose } from "react-icons/io";
import { Controller } from "react-hook-form";

export const SingleSelectDropDown = ({
  name,
  option,
  placeholder,
  label,
  control,
  rules,
  isRequired,
  labelStyle,
  value: initialValue,
  disabled = false,
  hasSearched = false,
  isClearable,
  onSelectionChange, // Callback function to pass value back to the parent
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: 28,
      padding: 4,
      backgroundColor: disabled ? "#e9ecef" : "white",
      border: state.selectProps.error
        ? "1px solid #ef4444"
        : "1px solid #e9ecef",
      borderColor: state.isFocused
        ? "#3b82f6"
        : state.selectProps.error
        ? "#ef4444"
        : "#e9ecef",
      boxShadow: state.isFocused
        ? state.selectProps.error
          ? "0 0 0 4px #FF808066"
          : "0 0 0 4px #63AAFF80"
        : "none",
      "&:hover": {
        borderColor: state.selectProps.error
          ? "#ef4444"
          : state.isFocused
          ? "#3b82f6"
          : "#e9ecef",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      maxHeight: 200,
      backgroundColor: state.isSelected
        ? "#9CA3AF"
        : state.isFocused
        ? "#D1D5DB"
        : "white",
      color: state.isSelected ? "white" : "black",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 200,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
    }),
  };

  const ClearIndicator = (props) => {
    const {
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div {...restInnerProps} ref={ref} className="text-md cursor-pointer">
        <IoMdClose />
      </div>
    );
  };

  const onChangeDropdown = (field, selectedOption) => {
    field.onChange(selectedOption || null);
    if (hasSearched && onSelectionChange) {
      onSelectionChange(selectedOption); // Notify parent component
    }
  };

  return (
    <div>
      <label
        className={`${
          labelStyle
            ? labelStyle
            : "block text-input-label text-sm font-bold mb-1.5"
        }`}
        htmlFor={name}
      >
        {label}
        {isRequired && " *"}
      </label>
      <Controller
        name={name}
        control={control}
        defaultValue={initialValue}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <>
            <Select
              className="text-gray-700 font-roboto text-sm whitespace-nowrap z-30"
              options={option}
              styles={customStyles}
              placeholder={placeholder}
              isDisabled={disabled}
              //isClearable={!isRequired}
              isClearable={isClearable !== undefined ? isClearable : !isRequired}
              onChange={(selectedOption) => {
                onChangeDropdown(field, selectedOption);
              }}
              //value={field.value || initialValue}
              value={field.value}
              error={!!error}
              components={{
                IndicatorSeparator: () => null,
                ClearIndicator,
                DropdownIndicator: () => (
                  <div className="text-lg">
                    <IoMdArrowDropdown />
                  </div>
                ),
              }}
            />
            {error && (
              <p className="text-red-500 text-sm pt-1 font-roboto font-thin">
                {error.message}
              </p>
            )}
          </>
        )}
      />
    </div>
  );
};
